import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  adjustStepper(): void {
    const stepperHeader = document.getElementById('stepperHeader');
    if (!stepperHeader) return;

    const stepperHeaderContainer: any = document.querySelector(
      '.mat-horizontal-stepper-header-container'
    );
    if (!stepperHeaderContainer) return;

    stepperHeaderContainer.style.transform = 'scale(0.8)';
    stepperHeaderContainer.style.transformOrigin = 'center right';

    const offY = stepperHeaderContainer.offsetHeight / 2;

    const x = stepperHeader.getBoundingClientRect().x;

    const right = window.innerWidth - x;
    stepperHeaderContainer.style.position = 'absolute';
    stepperHeaderContainer.style.top = stepperHeader.offsetTop - offY + 'px';
    stepperHeaderContainer.style.right = right + 'px';
    if (window.innerWidth <= 1024) {
      stepperHeaderContainer.style.transformOrigin = 'center left';
      stepperHeaderContainer.style['flex-wrap'] = 'wrap';
      stepperHeaderContainer.style.position = 'unset';
    }
  }

  private getUserAgent(): string {
    return (
      navigator.userAgent || navigator.vendor || (window as any).opera || ''
    );
  }

  isWindowsPhone(): boolean {
    return /IEMobile|Windows Phone/i.test(this.getUserAgent());
  }

  isBlackBerry(): boolean {
    return /BlackBerry|BB10/i.test(this.getUserAgent());
  }

  isOperaMini(): boolean {
    return /OperaMini/i.test(this.getUserAgent());
  }

  isAndroidPhone(): boolean {
    const ua = this.getUserAgent();
    return /Android/i.test(ua) && /Mobile/i.test(ua);
  }

  isAndroidTablet(): boolean {
    const ua = this.getUserAgent();
    return /Android/i.test(ua) && !/Mobile/i.test(ua);
  }

  isIPhone(): boolean {
    const ua = this.getUserAgent();
    return /iPhone/.test(ua);
  }

  isSafari(): boolean {
    const ua = this.getUserAgent();

    const hasSafari = ua.includes('Safari');
    const isChrome =
      ua.includes('Chrome') || ua.includes('Chromium') || ua.includes('CriOS');
    const isEdge = ua.includes('Edg/');
    const isOpera = ua.includes('OPR/');

    return hasSafari && !isChrome && !isEdge && !isOpera;
  }

  isMacDesktop(): boolean {
    const ua = this.getUserAgent();
    const isMac = ua.includes('Macintosh') || ua.includes('Mac OS X');

    if (ua.includes('iPhone') || ua.includes('iPad') || ua.includes('iPod')) {
      return false;
    }

    const hasTouch =
      (navigator as any).maxTouchPoints &&
      (navigator as any).maxTouchPoints > 1;

    return isMac && !hasTouch;
  }

  isMacSafari(): boolean {
    return this.isMacDesktop() && this.isSafari();
  }

  isIPad(): boolean {
    const ua = this.getUserAgent();
    if (ua.includes('iPad')) {
      return true;
    }
    if (ua.includes('iPhone') || ua.includes('iPod')) {
      return false;
    }
    const isMac = ua.includes('Macintosh');
    const hasTouch =
      (navigator as any).maxTouchPoints &&
      (navigator as any).maxTouchPoints > 1;

    return isMac && !!hasTouch;
  }

  isPhone(): boolean {
    const ua = this.getUserAgent();
    return (
      this.isIPhone() ||
      this.isAndroidPhone() ||
      this.isWindowsPhone() ||
      this.isBlackBerry() ||
      this.isOperaMini() ||
      (/Mobile/i.test(ua) && !this.isIPad() && !this.isAndroidTablet())
    );
  }
}
